export const URL_MENU = 'valueLists/PARENT_PROPERTIES_GROUP';
